import PageHeader from 'components/pageHeader/PageHeader';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from 'components/button/Button';
import Loader from 'components/loader/Loader';
import PermissionsAwareFieldset from '../common/PermissionsAwareFieldset';
import PropertyEditActionWrapper from '../common/PropertyEditActionWrapper';
import PropertyEditPermissionInfo from '../common/PropertyEditPermissionInfo';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import {
  NoOwnerMessage,
  OwnerDescription,
} from './PropertySettingsOwnersTab.styles';
import usePropertyOwners from './usePropertyOwners';
import PropertySettingsOwnersTable from './sections/propertySettingsOwnersTable/PropertySettingsOwnersTable';
import useOwnerModal from './modals/ownerModal/useOwnerModal';
import CommunicationSettings from './sections/propertySettingsOwnersTable/communicationSettings/CommunicationSettings';

const PropertySettingsOwnersTab = () => {
  const { t } = useTranslation();
  const { openAddOwnerModal } = useOwnerModal();
  const { property, isLoading: isLoadingProperty } =
    usePropertySettingsInitData();
  const { data: propertyOwnersData, isFetching: isFetchingPropertyOwners } =
    usePropertyOwners({
      propertyUid: property.uid as string,
      enabled: !!property.uid,
    });

  const owner = propertyOwnersData?.propertyOwnership?.owner;
  const hasNoOwners = !isFetchingPropertyOwners && !owner;
  const isLoading = isLoadingProperty || isFetchingPropertyOwners;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section>
      <PropertyEditPermissionInfo />
      <PermissionsAwareFieldset>
        <PageHeader
          className="owners-title"
          title={
            <Trans
              i18nKey="pageProperty.owners.tabTitle"
              values={{ propertyName: property?.name }}
              components={{ 1: <span className="green" /> }}
            />
          }
          noDivider
          buttons={
            hasNoOwners ? (
              <PropertyEditActionWrapper tooltipId="add-owner-btn-tooltip">
                <Button
                  bsStyle="primary"
                  data-testid="add-owner-btn"
                  onClick={openAddOwnerModal}
                >
                  {t('pageProperty.owners.addOwner')}
                </Button>
              </PropertyEditActionWrapper>
            ) : null
          }
        />

        <OwnerDescription data-testid="owners-description">
          <Trans
            i18nKey="pageProperty.owners.description"
            components={{
              1: (
                <Link
                  to="https://help.hostfully.com/en/articles/1674802-use-the-owner-portal"
                  target="_blank"
                />
              ),
            }}
          />
        </OwnerDescription>

        {hasNoOwners ? (
          <NoOwnerMessage data-testid="no-owner-message">
            {t('pageProperty.owners.noOwnerMessage')}
          </NoOwnerMessage>
        ) : (
          <>
            <PropertySettingsOwnersTable owner={owner!} />
            <CommunicationSettings propertyOwnersData={propertyOwnersData} />
          </>
        )}
      </PermissionsAwareFieldset>
    </section>
  );
};

export default PropertySettingsOwnersTab;
